<template>
    <div>          <div class="banner">
     <div class="slg"> <p class="slg_title1">新闻中心</p>
       <p class="slg_title2">诚信为基共筑未来 贴心服务助力企业发展</p></div>

   </div>
<div class="news-main">
  <div class="article">
            <p class="title">北京冠捷时速信用管理有限责任公司为信用中国公示第一批可出具信用报告的信用服务机构</p>
            <br>
            <p class="message"><span>时间：2024-10-16 01:25</span><!--<span>来源：青海新闻网</span>--><span>浏览次数：2182</span>
            </p>
            <div class="article_line"></div>
            <div class="arti_con">
                <img src="../../assets/img/news/gjgs1.png">
                <p>北京冠捷时速信用管理有限责任公司为信用中国公示第一批可出具信用报告的信用服务机构</p>

            </div>
        </div>
</div></div>
</template>

<script>
export default {
  name: 'news2024101702'
}
</script>

<style scoped>
.article {
    width: 90%;
    height: auto;
    padding-top: 30px;
    padding-bottom: 30px;
    margin: auto;
}
  .article .title {
    border: none;
    font-size: 24px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #1267aa;
    line-height: 45px;
}
  .article .article_line {
    width: 100%;
    height: 2px;
    background: #ccc;
    margin: 20px auto;
}
  .article .title, .message, .article_line {
    text-align: center;
}
  .message, .article_line {
    text-align: center;
}
  .article p span {
    margin-right: 60px;
}
  .article .arti_con img {
    display: block;
    max-width: 50%;
    margin: 20px auto;
}
  .news-main{
    width: 1250px;
    margin: auto;
  }
      .banner {
    background-image: url(../../assets/img/bg1.jpg);
    background-size: cover;
    background-position: center;
    height: 560px;
    overflow: hidden;
}
      .slg{
    width: 1200px;
    margin: auto;
    padding-top: 200px;
  }
    .slg_title1{
    font-size: 50px;
    color: #d46700;
    margin: 0px 0px 0px 0px;
  }
    .slg_title2{
      margin: 20px 0px 0px 0px;
    font-size: 40px;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/view/news/news2024101702.vue